module.exports = __webpack_public_path__ + "static/media/lupa.22bfcf5d.svg";